module.exports = __webpack_public_path__ + "img/toma_web.327d623b.webp";